import { MaterialCategory } from './material-category.model';
import { MaterialVendor } from './material-vendor.model';
import { Vendor } from './vendor.model';

export class Materials {
  materialCategories: MaterialCategory[];
  materialVendors: MaterialVendor[];
  vendors: Vendor[];
}
